import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { AppComponent } from '@pages/app.component';
import { providers } from './app/pages/app.providers';
import { bootstrapPlugins } from './bootstrap';

/**
 * @description Import global variants of the locale data.
 * @see https://angular.dev/guide/i18n/import-global-variants#import-example-for-french
 */
import '@angular/common/locales/global/en';
import '@angular/common/locales/global/id';

if (environment.production) {
  enableProdMode();
}

bootstrapPlugins();
bootstrapApplication(AppComponent, { providers });
